import { DatePipe } from '@angular/common';
import { Component, EventEmitter, ElementRef, Inject, Input, OnInit, TemplateRef, ViewChild, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ICellRendererParams } from 'ag-grid-community';
import { differenceInCalendarDays } from 'date-fns';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/internal/operators/finalize';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { PriorityLevel } from 'src/@smartmanufacturing/common/enum';
import { ImageDialogComponent } from 'src/app/analytical-tools/image-dialog/image-dialog.component';
import { OverallActionPlanService } from 'src/app/services/overall-actionPlan.service';
import { TranslaterService } from 'src/app/services/translater.service';
import { UserConfigurationsService } from 'src/app/services/user-configurations.service';
import { BaseApi } from 'src/backend/api/base-api';
import { ActionPlanData, ActionPlanConstants } from 'src/app/models/action-plan-data.interface';

@Component({
  selector: 'app-addActionModal',
  templateUrl: './addActionModal.component.html',
  styleUrls: ['./addActionModal.component.scss']
})
export class AddActionModalComponent {
  @Output() actionSaveUpdateEvent: EventEmitter<any> = new EventEmitter();
  langObj: any;
  addActionForm: FormGroup;
  @ViewChild('addActionModal') private addActionModal!: TemplateRef<any>;
  @ViewChild('imageInput') imageInput!: ElementRef;
  @ViewChild('fileInput') fileInput!: ElementRef;
  Headerform!: FormGroup;
  masterUserList: any = [];
  gridApiActions: any;
  gridColumnApiActions: any;
  columnDefsallAction: any;
  editMode: boolean = false;
  overallActions: any[];
  Status: any;
  departmentListMachine!: any;
  filteredDepartmentListMachine!: any;
  actionSelectedRow: any;
  blobStorageUrl = Constants.BLOB_STORAGE_URL;
  actionId: any;
  displayMaximizable = false;
  imageIndexOne = 0;
  ModuleName: any;
  UniqueCode: any;
  HeaderId: any;
  currentAssigneeEmail: string = null;
  currentResponsibleEmail: any = null;
  currentNodeDate: any = null;
  showDepartment: boolean = true;
  addStatus = 'Open';
  addClosedDate: any;
  addVerificationBy: string = '';
  doc!: any;
  images: any[] = [];
  fileType!: string;
  fileDesc: any;
  imagefile: any;
  imagefileUrl: any;
  filefile: any;
  filefileUrl: any;
  closefile: any;
  closefileUrl: any;
  completefile: any;
  completefileUrl: any;
  mClassificationTypes: any[] = [];
  pageId: any;
  moduleId: any;
  languageDir = 'ltr';
  MissesCondition: boolean;
  nzDateTimeFormat: any;
  nzDateFormat: any;
  nzTimeFormat: any;
  userSession: any;
  Levels = [
    { Id: PriorityLevel.High, Name: 'High' },
    { Id: PriorityLevel.Medium, Name: 'Medium' },
    { Id: PriorityLevel.Low, Name: 'Low' }
  ];
  IsAssignedToCreator: any;
  IsAssignedToCurrentUser: any;
  IsLoggedInUserCreator: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public inputData: {
      message: string,
      userList: [],
      ID: any,
      ModuleId: any,
      editMode: any,
      params: any,
      TableId: any,
    },

    private dialogRef: MatDialogRef<AddActionModalComponent>,
    private dialog: MatDialog,
    private toaster: ToastrService,
    public datePipe: DatePipe,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    public translate: TranslateService,
    private actionplanService: OverallActionPlanService,
    private baseApi: BaseApi,
    private translater: TranslaterService,
    private userConfigService: UserConfigurationsService
  ) {
    this.nzDateTimeFormat = this.userConfigService.getDateFormat('date-time');
    this.nzDateFormat = this.userConfigService.getDateFormat('date');
    this.nzTimeFormat = this.userConfigService.getDateFormat('time');
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ? this.languageDir = 'rtl' : this.languageDir = 'ltr'; this.getLangWords(); });
    this.addActionForm = this.fb.group({
      rootcause: [''],
      action: ['', Validators.required],
      mClassification: [''],
      actionType: ['', Validators.required],
      assignTo: ['', Validators.required],
      priorityLevel: ['', Validators.required],
      targetDate: [''],
      revisedDate: [''],
      completed: [''],
      verification: [''],
      departmentMachine: [],
      newAssignee: [''],
      closefile: [''],
      completeFile: [''],
      remarks: [''],
      NoofMisses: ['']
    });
  }

  ngOnInit() {
    this.userSession = this.baseApi.getUserSession();
    this.addActionForm.get('actionType')?.setValue('Corrective');
    this.masterUserList = this.inputData.userList;
    // this.getDepartmentsMachine();
    this.getLangWords();
    if (this.inputData.ModuleId == 0) {
      this.showDepartment = false;
    }
    else {
      this.showDepartment = true;
    }
    if (this.inputData.editMode) {
      this.editMode = this.inputData.editMode;
      this.editRow(this.inputData?.params);
    }
    this.getMClassificationList();
  }

  getMClassificationList() {
    this.actionplanService.getMClassification().subscribe(
      (response) => {
        this.mClassificationTypes = response;
      },
      (error) => {
        this.toaster.error('Error', 'Something Went Wrong');
      }
    );
  }

  localizeHeader(parameters: ICellRendererParams): string {
    const headerIdentifier = parameters.colDef.field;
    return this.translate.instant(headerIdentifier);
  }

  openFile(type: any): void {
    if (type === 'pic') {
      this.imageInput.nativeElement.click();
    } else {
      this.fileInput.nativeElement.click();
    }
  }

  readFile(event: any, type: any): void {
    if (event.target.files.length !== 1) throw new Error('Cannot use multiple files');
    const allowedImageTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    const allowedOtherTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', 'application/pdf'];
    if (type === 'pic') {
      if (!allowedImageTypes.includes(event.target.files[0].type)) {
        this.toaster.error('Error', 'Please upload only image file');
        return;
      }
      this.imagefile = event.target.files[0];
    } else {
      if (!allowedOtherTypes.includes(event.target.files[0].type)) {
        this.toaster.error('Error', 'Please upload only pdf or excel file');
        return;
      }
      this.filefile = event.target.files[0];
    }

    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (type === 'pic') {
          this.imagefileUrl = reader.result as string;
        } else {
          this.filefileUrl = reader.result as string;
        }
      };
    }
  }

  deleteFile(type: any): void {
    if (type === 'pic') {
      this.imagefileUrl = '';
      this.imagefile = '';
    } else {
      this.filefile = '';
      this.filefileUrl = '';
    }
  }

  imageZoomModal(): void {
    if (this.editMode == false) {
      this.dialog.open(ImageDialogComponent, {
        height: '90%',
        width: '90%',
        data: this.imagefileUrl,
      });
    } else {
      this.dialog.open(ImageDialogComponent, {
        height: '90%',
        width: '90%',
        data: this.data.addImageSrc || Constants.BLOB_STORAGE_URL + this.data.UploadFile,
      });
    }
  }

  data: any = [];

  downloadPDF() {
    if (!this.filefileUrl) return;
    var a = document.createElement("a"); //Create <a>
    a.href = this.filefileUrl; //Image Base64 Goes here
    a.download = "file.pdf";
    a.click();
  }

  addGetMinDate(type: any): any {
    if (type === 'Revised') {
      const date = this.addActionForm.value.targetDate
        ? this.addActionForm.value.RevisedDate
        : this.addActionForm.value.TargetDate;
      const currentDate = new Date(date);

      const minDateStartFrom = new Date(
        currentDate.setDate(currentDate.getDate() + 1)
      );

      return (current: Date): boolean =>
        differenceInCalendarDays(current, minDateStartFrom) < 0;
    } else if (type === 'Target') {
      const currentDate = new Date();
      const minDateStartFrom = new Date(
        currentDate.setDate(currentDate.getDate())
      );

      return (current: Date): boolean =>
        differenceInCalendarDays(current, minDateStartFrom) < 0;
    }
  }

  getMinDate(type: any): any {
    if (type === 'Revised') {
      const date = this.addActionForm.value.revisedDate
        ? this.addActionForm.value.revisedDate
        : this.addActionForm.value.targetDate;
      const currentDate = new Date(date);

      const minDateStartFrom = new Date(
        currentDate.setDate(currentDate.getDate() + 1)
      );

      return (current: Date): boolean =>
        differenceInCalendarDays(current, minDateStartFrom) < 0;
    } else if (type === 'Target') {
      const currentDate = new Date();
      const minDateStartFrom = new Date(
        currentDate.setDate(currentDate.getDate())
      );

      return (current: Date): boolean =>
        differenceInCalendarDays(current, minDateStartFrom) < 0;
    }
  }

  addDisableVerification = true;
  disableVerification = true;
  addDisableNewAssigne = true;
  showCloseFileInput: boolean;
  showCompleteFileInput: boolean = false;
  showinput: boolean;

  onChangeComplete(formMode: 'add' | 'edit'): void {
    const completed = this.addActionForm.value.completed === ActionPlanConstants.COMPLETION_YES;
    let shouldDisableVerification: boolean;

    if (formMode === 'edit') {
      this.updateRowAssignmentFlags(this.data);

      const statusLocked = this.data?.Status === 'Complete' || this.data?.Status === 'Closed';

      // Complete File belongs to the assignee (incl. a creator who is also the assignee)
      this.showCompleteFileInput = this.editIsAssignee && completed && !statusLocked;

      if (!this.editIsCreator) {
        // Assignee-only: completing is allowed but verification is never theirs
        this.disableVerification = true;
        this.addDisableVerification = true;
        this.addActionForm.get('verification')?.setValue(ActionPlanConstants.EMPTY_STRING);
        return;
      }

      // Creator (incl. creator-assignee): verification follows completion
      shouldDisableVerification =
        this.data?.Status === ActionPlanConstants.STATUS_CLOSED ||
        !completed;
    } else {
      // Add mode
      shouldDisableVerification =
        this.addStatus === ActionPlanConstants.STATUS_CLOSED ||
        !completed ||
        this.IsLoggedInUserCreator === false;
      this.showCompleteFileInput = !shouldDisableVerification;
    }

    this.addDisableVerification = shouldDisableVerification;
    this.disableVerification = shouldDisableVerification;
    this.addActionForm.get('verification')?.setValue(ActionPlanConstants.EMPTY_STRING);
  }

  onChangeVerification(): void {
    const { verification } = this.addActionForm.value;
    this.addDisableNewAssigne = this.shouldDisableNewAssignee(verification);
    // Close File is only for the creator (edit mode) or when in add mode where the creator is the same person
    this.showCloseFileInput = verification === ActionPlanConstants.VERIFICATION_APPROVED &&
      (this.editMode ? this.editIsCreator : true);
    
    // Handle remarks requirement for disapproved verification
    if (verification === 'Disapproved') {
      // Set remarks as required when verification is disapproved
      this.addActionForm.get('remarks')?.setValidators([Validators.required]);
    } else {
      // Remove required validation when not disapproved
      this.addActionForm.get('remarks')?.clearValidators();
    }
    this.addActionForm.get('remarks')?.updateValueAndValidity();
  }

  /**
   * Determines whether new assignee dropdown should be disabled
   * TODO: Extract to shared ActionPlanPermissionsService (Task #XXXX)
   * This logic is duplicated across 6 components
   */
  private shouldDisableNewAssignee(verification: string): boolean {
    if (!this.data) {
      return true; // Disable by default if no data
    }

    const {
      Status = ActionPlanConstants.EMPTY_STRING,
      IsLoggedInUserCreator = false,
      ActionCompletedOn = null,
      ActionCompleted = ActionPlanConstants.EMPTY_STRING
    } = this.data;

    const isActionCompleted = !!ActionCompletedOn && ActionCompleted === ActionPlanConstants.EMPTY_STRING;

    const shouldDisable =
      verification !== ActionPlanConstants.VERIFICATION_DISAPPROVED ||
      Status === ActionPlanConstants.STATUS_CLOSED ||
      IsLoggedInUserCreator === false ||
      isActionCompleted;


    return shouldDisable;
  }

  /**
   * Updates assignment permission flags for data row
   * TODO: Extract to shared ActionPlanPermissionsService (Task #XXXX)
   */

  /**
   * Normalises an employee code for comparison.
   * The SP returns codes as NVARCHAR (possible trailing spaces) and uses
   * ISNULL(AssignTo, 0) which can yield the integer 0 for unassigned rows,
   * so a strict === against the session userCode (string) can silently fail.
   * Returns an empty string for null/undefined/0 so unassigned never matches.
   */
  private normalizeCode(value: any): string {
    if (value == null || value === 0 || value === '0') {
      return '';
    }
    return String(value).trim();
  }

  /** True only when both codes are non-empty and equal after normalisation. */
  private sameCode(a: any, b: any): boolean {
    const na = this.normalizeCode(a);
    const nb = this.normalizeCode(b);
    return na !== '' && na === nb;
  }

  updateRowAssignmentFlags(data: ActionPlanData): void {
  if (!this.data) {
    return;
  }

  // Use NewAssigneeId if available, otherwise fall back to AssignTo
  const effectiveAssignee =
    this.normalizeCode(this.data?.NewAssigneeId) !== ''
      ? this.data.NewAssigneeId
      : this.data.AssignTo;

  const userCode = this.userSession?.userCode;

  this.data.IsAssignedToCreator = this.sameCode(effectiveAssignee, this.data.CreatedBy);
  this.data.IsAssignedToCurrentUser = this.sameCode(effectiveAssignee, userCode);
  this.data.IsLoggedInUserCreator = this.sameCode(userCode, this.data.CreatedBy);
}



  /**
   * Updates assignment flags for add form mode
   * TODO: Extract to shared ActionPlanPermissionsService (Task #XXXX)
   */
  updateAssignmentFlags(): void {
    const { assignTo } = this.addActionForm.value;
    const currentUserCode = this.userSession?.userCode;

    if (!assignTo || !currentUserCode) {
      this.IsAssignedToCreator = undefined;
      this.IsAssignedToCurrentUser = undefined;
      this.IsLoggedInUserCreator = undefined;
      return;
    }

    this.IsAssignedToCreator = assignTo === currentUserCode;
    this.IsAssignedToCurrentUser = assignTo === currentUserCode;
    this.IsLoggedInUserCreator = true;

    if (!this.IsAssignedToCreator) {
      this.addActionForm.get('completed').setValue(ActionPlanConstants.COMPLETION_NO);
      this.addActionForm.get('verification').setValue(ActionPlanConstants.EMPTY_STRING);
      this.addDisableVerification = true;
    }
  }

  targetDate: any;
  RevisedDate: any;
  addAction(): void {
    // Check for mandatory remarks when verification is disapproved
    if (this.addActionForm.value.verification === 'Disapproved' && (!this.addActionForm.value.remarks || this.addActionForm.value.remarks.trim() === '')) {
      this.toaster.warning('Warning', 'Please Fill The Remarks Field');
      return;
    }

    this.targetDate = this.addActionForm.value.targetDate;
    this.addStatus = this.addActionForm.value.targetDate && !this.addActionForm.value.revisedDate ? 'InProgress' : this.addActionForm.value.targetDate && this.addActionForm.value.revisedDate ? 'Delayed' : 'Open';

    if (this.addActionForm.value.completed === 'Yes') {
      this.addStatus = 'Complete';
    }

    if (this.addActionForm.value.verification === 'Approved') {
      this.addStatus = 'Closed';
    } else if (this.addActionForm.value.verification === 'Disapproved') {
      this.addStatus = 'ReOpened';
      this.addActionForm.get('completed').setValue('No');
    }
    const formdata = new FormData();
    formdata.append('file', this.filefile);
    formdata.append('image', this.imagefile);
    formdata.append('closedFile', this.closefile);
    formdata.append('completedFile', this.completefile);
    if (this.addActionForm.value.targetDate) {
      this.targetDate = this.addActionForm.value.targetDate;
      this.targetDate = new Date(this.targetDate);
      this.targetDate.setHours(new Date().getHours());
      this.targetDate.setMinutes(new Date().getMinutes());
      this.targetDate.setSeconds(new Date().getSeconds());
    }
    if (this.addActionForm.value.revisedDate) {
      this.RevisedDate = this.addActionForm.value.revisedDate;
      this.RevisedDate = new Date(this.RevisedDate);
      this.RevisedDate.setHours(new Date().getHours());
      this.RevisedDate.setMinutes(new Date().getMinutes());
      this.RevisedDate.setSeconds(new Date().getSeconds());
    }
    const key = {
      actionName: this.addActionForm.value.action,
      priorityLevel: this.addActionForm.value.priorityLevel,
      actionType: this.addActionForm.value.actionType,
      responsible: this.addActionForm.value.assignTo,
      departmentId: this.addActionForm.value.departmentMachine,
      targetDate: this.targetDate ? this.targetDate : null,
      revisedDate: this.RevisedDate ? this.RevisedDate : null,
      actionCompleted: this.addActionForm.value.completed,
      Verification: this.addActionForm.value.verification,
      remarks: this.addActionForm.value.remarks,
      rootcause: this.addActionForm.value.rootcause,
      newAssignee: this.addActionForm.value.newAssignee
        ? this.addActionForm.value.newAssignee
        : null,
      status: this.addStatus,
      ID: this.inputData.ID,
      ModuleId: this.inputData.ModuleId,
      TableId: this.inputData.TableId ? this.inputData.TableId : null,
      mClassification: this.addActionForm.value?.mClassification
    };
    formdata.append('values', JSON.stringify(key));
    this.spinner.show();
    this.actionplanService.AddActionUserAction(formdata).pipe(finalize(() => {
      this.dialogRef.close(true);
      this.actionSaveUpdateEvent.emit(true); // custom event emitter;
      this.spinner.hide();
    })).subscribe(({
      next: (res: any) => {
        this.toaster.success('Success', 'Saved Successfully');
        this.resetForm();
      },
      error: (res: any) => {
        this.toaster.error('Error')
      }
    }))
  }

  resetForm() {
    this.editMode = false;
    this.imagefile = '';
    this.imagefileUrl = '';
    this.filefile = '';
    this.filefileUrl = '';
    this.closefile = '';
    this.closefileUrl = '';
    this.completefile = '';
    this.completefileUrl = '';
    this.showCloseFileInput = false;
    this.showCompleteFileInput = false;
    this.addActionForm.reset();
  }

  isResetButtonEnabled(): boolean {
    const formValues = this.addActionForm.value;
    for (const key in formValues) {
      if (formValues.hasOwnProperty(key) && formValues[key]) {
        return true;
      }
    }
    return false;
  }

  onGridReadyAction(params: any): any {
    this.gridApiActions = params.api;
    this.gridColumnApiActions = params.columnApi;
  }

  disableNewAssigne = true;

  editRow(params: any): void {
    if (!params) return;
    this.data = [];

    this.imagefile = '';
    this.filefile = '';
    this.closefile = '';
    this.completefile = '';
    this.imagefileUrl = '';
    this.filefileUrl = '';
    this.closefileUrl = '';
    this.completefileUrl = '';

    this.data = params;
    this.updateRowAssignmentFlags(this.data);

    // Requirement 2D: assignee can complete without a target date
    if (this.editIsAssigneeOnly) {
      this.addActionForm.get('targetDate')?.clearValidators();
      this.addActionForm.get('targetDate')?.updateValueAndValidity();
    }

    this.ModuleName = params.Module;
    this.UniqueCode = params.UniqueCode;
    this.HeaderId = params.HeaderId;
    this.currentAssigneeEmail = params.AssigneEmail;
    this.currentResponsibleEmail = params.ParticpantEmails;
    this.currentNodeDate = params.ObservedDate;
    this.addActionForm.get('action').setValue(params.Action);
    this.addActionForm.get('priorityLevel').setValue(params.PriorityLevel);
    this.addActionForm.get('assignTo').setValue(params.AssignTo);
    this.addActionForm.get('completed').setValue(params.ActionCompleted);
    this.addActionForm.get('remarks').setValue(params.Remarks);
    this.MissesCondition = true;

    // Verification field: only enabled for the creator when ActionCompleted = Yes and not Closed
    const verificationEnabled =
      params.ActionCompleted === 'Yes' &&
      params.Status !== 'Closed' &&
      this.editIsCreator;

    if (!verificationEnabled) {
      this.disableVerification = true;
      this.addDisableVerification = true;
      this.addActionForm.get('verification').setValue(params.Verification ? params.Verification : '');
    } else {
      this.disableVerification = false;
      this.addDisableVerification = false;
      this.addActionForm.get('verification').setValue(params.Verification);
    }

    // Complete File: only for assignee-only when they have completed the action and it's not locked
    const statusLocked = params.Status === 'Complete' || params.Status === 'Closed';
    this.showCompleteFileInput = this.editIsAssignee && params.ActionCompleted === 'Yes' && !statusLocked;

    // Close File & New Assignee: creator-only
    if (params.Verification === 'Disapproved') {
      this.disableNewAssigne = !this.editIsCreator;
      this.showCloseFileInput = false;
      this.addActionForm.get('newAssignee').setValue(params.NewAssigneeId);
    } else if (params.Verification === 'Approved' && !params.NewAssigneeId) {
      this.showCloseFileInput = this.editIsCreator;
      this.disableNewAssigne = true;
      this.addActionForm.get('newAssignee').setValue('');
    } else {
      this.showCloseFileInput = false;
      this.addActionForm.get('newAssignee').setValue(params.NewAssigneeId);
    }

    this.addActionForm.get('actionType').setValue(params.ActionType);
    if (params.RevisedDate !== null) {
      this.addActionForm.get('revisedDate').setValue(this.datePipe?.transform(new Date(params.RevisedDate), 'yyyy-MM-dd'));
    }
    if (params.TargetDate !== null) {
      this.addActionForm.get('targetDate').setValue(this.datePipe?.transform(new Date(params.TargetDate), 'yyyy-MM-dd'));
    }
    this.targetDate = params.TargetDate;
    this.addActionForm.get('rootcause')?.setValue(params.RootCause);
    this.addActionForm.get('mClassification')?.setValue(params.M_Classification);
    this.addActionForm.get('NoofMisses').setValue(params.NoOfMisses);

  }

  closeFile(event: any): void {
    if (event.target.files.length === 0) return;
    this.closefile = event.target.files[0];
  }

  completeFile(event: any): void {
    if (event.target.files.length === 0) return;
    this.completefile = event.target.files[0];
  }

  /*, will be needed later
  getDepartmentsMachine(): void {
    const key = {};
    this.departmentListMachine = [];
    this.filteredDepartmentListMachine = [];
    this.actionplanService.getDeptData(key).subscribe((res) => {
      this.departmentListMachine = res;
      this.filteredDepartmentListMachine = this.departmentListMachine.slice();
      if(this.editMode) {
        this.addActionForm.get('departmentMachine')?.setValue(this.inputData?.params.TypeId);
      }
      else {
        this.addActionForm.get('departmentMachine')?.setValue(this.departmentListMachine[0].TypeId);
      }
    },
    (error)=>{
      this.toaster.error('Error', error.message);
    });
  }
  */

  updateActionPlan(): void {
    // Check for mandatory remarks when verification is disapproved
    if (this.addActionForm.value.verification === 'Disapproved' && (!this.addActionForm.value.remarks || this.addActionForm.value.remarks.trim() === '')) {
      this.toaster.warning('Warning', 'Please Fill The Remarks Field');
      return;
    }

    this.Status = '';
    this.Status =
      this.addActionForm.value.targetDate &&
        !this.addActionForm.value.revisedDate
        ? 'InProgress'
        : this.addActionForm.value.targetDate &&
          this.addActionForm.value.revisedDate
          ? 'Delayed'
          : 'Open';

    if (this.addActionForm.value.targetDate) {
      this.targetDate = this.addActionForm.value.targetDate;
      this.targetDate = new Date(this.targetDate);
      this.targetDate.setHours(new Date().getHours());
      this.targetDate.setMinutes(new Date().getMinutes());
      this.targetDate.setSeconds(new Date().getSeconds());
    }
    if (this.addActionForm.value.revisedDate) {
      this.RevisedDate = this.addActionForm.value.revisedDate;
      this.RevisedDate = new Date(this.RevisedDate);
      this.RevisedDate.setHours(new Date().getHours());
      this.RevisedDate.setMinutes(new Date().getMinutes());
      this.RevisedDate.setSeconds(new Date().getSeconds());
    }
    if (this.addActionForm.value.completed === 'Yes') {
      this.Status = 'Complete';
    }
    if (this.addActionForm.value.verification === 'Approved') {
      this.Status = 'Closed';
    } else if (this.addActionForm.value.verification === 'Disapproved') {
      this.Status = 'ReOpened';
      this.addActionForm.get('completed').setValue('No');
    }

    const formdata = new FormData();
    formdata.append('file', this.filefile);
    formdata.append('image', this.imagefile);
    formdata.append('closedFile', this.closefile);
    formdata.append('completedFile', this.completefile);

    const key = {
      actionId: this.inputData.params.ActionId,
      actionName: this.addActionForm.value.action,
      PriorityLevel: this.addActionForm.value.priorityLevel,
      actionType: this.addActionForm.value.actionType,
      responsible: this.addActionForm.value.assignTo,
      TableId: this.inputData.TableId,
      ModuleId: this.inputData.ModuleId,
      departmentId: this.addActionForm.value.departmentMachine,
      targetDate: this.targetDate ? this.targetDate : null,
      revisedDate: this.RevisedDate ? this.RevisedDate : null,
      actionCompleted: this.addActionForm.value.completed,
      Verification: this.addActionForm.value.verification,
      remarks: this.addActionForm.value.remarks,
      newAssignee: this.addActionForm.value.newAssignee
        ? this.addActionForm.value.newAssignee
        : null,
      status: this.Status,
      headerId: this.HeaderId,
      rootCause: this.addActionForm.value.rootcause,
      mClassification: this.addActionForm.value?.mClassification,
      NoofMisses: this.addActionForm.value.NoofMisses
    };

    formdata.append('values', JSON.stringify(key));
    this.spinner.show();
    this.actionplanService.editActionPlan(formdata).pipe(finalize(() => {
      this.dialogRef.close(true);
      this.spinner.hide();
      this.resetForm();
      this.actionSaveUpdateEvent.emit(true); // custom event emitter
    })).subscribe((res: any) => {
      const result = res?.[0];
      if (result?.IsAuthorizedVerifier === false) {
        this.toaster.warning('Warning', result.message);
      } else {
        this.toaster.success('Success', 'Updated Successfully');
      }
    },
      (error: any) => {
        this.toaster.error('Error', error.message);
      });
  }

  closeModal(): void {
    this.dialogRef.close();
    this.resetForm();
  }

  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    const userMenus = this.baseApi.getUserPermissionsSession();
    this.moduleId = userMenus.find(x => x.menuId === this.pageId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      // if (this.langObj) {
      //   this.gridApi.refreshHeader();
      // }
    });
  }


  onRevisedDateChange(row: any, data: any) {
    if (this.editMode) {


      if (this.MissesCondition && row) {
        const currentMisses = this.addActionForm.get('NoofMisses').value || 0;
        this.addActionForm.get('NoofMisses').setValue(currentMisses + 1);
        // data.NoOfMisses++;
        this.MissesCondition = false;
      } else if (!this.MissesCondition && !row) {
        const currentMisses = this.addActionForm.get('NoofMisses').value || 0;
        this.addActionForm.get('NoofMisses').setValue(currentMisses - 1);
        // data.NoOfMisses--;
        this.MissesCondition = true;
      }
    }
    // row.MinRevisedDate = (current: Date): boolean =>
    // // Can not select days before today and today
    // differenceInCalendarDays(current, new Date(row.TargetDate)) < 0;
  }

  // ── Edit-mode role helpers ──────────────────────────────────────────────────

  /** Logged-in user created this action */
  get editIsCreator(): boolean {
    return this.data?.IsLoggedInUserCreator === true;
  }

  /** Logged-in user is the assignee but NOT the creator */
  get editIsAssigneeOnly(): boolean {
    return this.data?.IsAssignedToCurrentUser === true && this.data?.IsLoggedInUserCreator !== true;
  }

  /**
   * Logged-in user is the assignee — whether or not they are also the creator.
   * "Action Completed" and "Complete File" belong to the assignee role, so a
   * creator who is also the assignee must be able to complete the action.
   */
  get editIsAssignee(): boolean {
    return this.data?.IsAssignedToCurrentUser === true;
  }

  /**
   * Creator's setup fields are locked when:
   * - 1B: Status is Complete or Closed
   * - 1C: ActionCompleted = 'Yes' (Verification status — creator may only attach Close File)
   */
  get editCreatorFieldsLocked(): boolean {
    const s = this.data?.Status;
    if (s === 'Complete' || s === 'Closed') return true;       // req 1B
    if (this.data?.ActionCompleted === 'Yes') return true;      // req 1C
    return false;
  }

  /**
   * Fields owned by the creator (Action, RootCause, AssignTo, etc.) should be
   * disabled for everyone else, and for the creator once locked.
   */
  get editDisableCreatorFields(): boolean {
    if (this.editIsCreator) return this.editCreatorFieldsLocked;
    return true; // assignee-only and non-participants cannot touch these
  }

  /**
   * Action Completed dropdown:
   * - Only the assignee (non-creator) may edit it.
   * - Locked once status is Complete or Closed.
   */
  get editDisableActionCompleted(): boolean {
    const s = this.data?.Status;
    if (s === 'Closed' || s === 'Complete') return true;
    if (this.editIsAssignee) return false; // assignee (incl. creator-assignee) may complete
    return true; // creator-only (non-assignee) and non-participants cannot edit
  }

  // ── End role helpers ─────────────────────────────────────────────────────────

  /**
   * Determines whether assignee dropdown should be disabled
   * @param data The action plan data (optional for add mode)
   * @param mode The form mode ('add' or 'edit')
   * TODO: Extract to shared ActionPlanPermissionsService (Task #XXXX)
   */
  isAssigneeDisabled(data: ActionPlanData | null = null, mode: string): boolean {
    if (mode === 'edit' && !data) {
      return true;
    }

    if (data?.Status === ActionPlanConstants.STATUS_CLOSED) {
      return true;
    }

    if (data?.Action === ActionPlanConstants.EMPTY_STRING) {
      return true;
    }

    if (data?.IsLoggedInUserCreator === false) {
      return true;
    }

    if (data?.ActionCompletedOn && 
        data.ActionCompletedOn !== ActionPlanConstants.EMPTY_STRING) {
      return true;
    }

    return false;
  }

  /**
   * Sets the assignment date and updates permission flags
   * TODO: Extract to shared ActionPlanPermissionsService (Task #XXXX)
   */
  setAssignDate(data: ActionPlanData): void {
    if (!data) {
      return;
    }

    data.AssignedDate = new Date();
    this.updateRowAssignmentFlags(data);
    
    // Case 1: Assignee = Creator AND Assignee = Logged-in user → Enable all steps
    if (data.IsAssignedToCreator && data.IsAssignedToCurrentUser) {
      return; // All steps enabled
    }
    
    // Case 2: Assignee = Creator but NOT logged-in user → Don't enable ActionCompleted
    if (data.IsAssignedToCreator && data.IsAssignedToCurrentUser === false) {
      this.resetActionFields(data);
      return;
    }
    
    // Case 3: Assignee ≠ Creator but Assignee = Logged-in user → Only enable ActionCompleted
    if (data.IsAssignedToCreator === false && data.IsAssignedToCurrentUser) {
      this.resetVerificationFields(data);
      return;
    }
    
    // Default case: Reset all fields
    this.resetActionFields(data);
  }

  /**
   * Resets all action and verification fields
   */
  private resetActionFields(data: ActionPlanData): void {
    data.ActionCompleted = ActionPlanConstants.COMPLETION_NO;
    data.ActionCompletedBy = ActionPlanConstants.EMPTY_STRING;
    data.ActionCompletedOn = ActionPlanConstants.EMPTY_STRING;
    this.resetVerificationFields(data);
  }

  /**
   * Resets verification fields only
   */
  private resetVerificationFields(data: ActionPlanData): void {
    data.Verification = ActionPlanConstants.EMPTY_STRING;
    data.VerificationBy = ActionPlanConstants.EMPTY_STRING;
    data.VerificationOn = ActionPlanConstants.EMPTY_STRING;
  }

}
